const chunk = (list, columns=3, balanced=true) => {
  if (columns < 2) {
    return [list];
  }

  const len = list.length;
  const out = [];
  let i = 0;
  let size;

  if (len % columns === 0) {
    size = Math.floor(len / columns);
    while (i < len) {
      out.push(list.slice(i, i += size));
    }
  } else if (balanced) {
    while (i < len) {
      size = Math.ceil((len - i) / columns--);
      out.push(list.slice(i, i += size));
    }
  } else {
    columns--;
    size = Math.floor(len / columns);
    if (len % size === 0) {
      size--;
    }

    while (i < size * columns) {
      out.push(list.slice(i, i += size));
    }

    out.push(list.slice(size * columns));
  }

  return out;
};

export { chunk };


// WEBPACK FOOTER //
// ./src/components/utils.js